import { SidebarProvider } from '@mntn/ui-components'
import { MfeThemeWrapper } from '../shared/mfe-theme-wrapper'
import { Dashboard, type DashboardProps } from './dashboard'
import { FilterProvider } from './filter-panel'

export const DashboardWrapper = (props: DashboardProps) => {
  return (
    <MfeThemeWrapper>
      <FilterProvider>
        <SidebarProvider defaultOpen={false}>
          <Dashboard {...props} />
        </SidebarProvider>
      </FilterProvider>
    </MfeThemeWrapper>
  )
}

export const DEBOUNCE_DELAY = 300
export const DEFAULT_FILTER_SECTIONS = {
  'offering-type': false,
  genres: false,
  'cpm-range': false,
  'air-dates': false,
}
